/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageUploadUrlRequest
 */
export interface ImageUploadUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof ImageUploadUrlRequest
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof ImageUploadUrlRequest
     */
    contentType: string;
}

/**
 * Check if a given object implements the ImageUploadUrlRequest interface.
 */
// @ts-ignore
export function instanceOfImageUploadUrlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "contentType" in value;

    return isInstance;
}

// @ts-ignore
export function ImageUploadUrlRequestFromJSON(json: any): ImageUploadUrlRequest {
    return ImageUploadUrlRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function ImageUploadUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageUploadUrlRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'contentType': json['content_type'],
    };
}

// @ts-ignore
export function ImageUploadUrlRequestToJSON(value?: ImageUploadUrlRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filename': value.filename,
        'content_type': value.contentType,
    };
}

